import { Component, OnInit, OnChanges, Input } from '@angular/core';

@Component({
    selector: 'app-products-info',
    templateUrl: './products-info.component.html',
    styleUrls: ['./products-info.component.scss']
})
export class ProductsInfoComponent implements OnInit, OnChanges {
    @Input() product: any;

    plant: string;
    projectManager: string;
    supportManager: string;


    constructor() { }

    ngOnInit() {
    }

    ngOnChanges() {
    }
}
